var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup19263(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.708,
    height: 17.564,
    viewBox: "0 0 13.708 17.564",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19263",
    "data-name": "Group 19263",
    transform: "translate(0 0.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16604",
    "data-name": "Group 16604"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16608",
    "data-name": "Group 16608",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10187",
    "data-name": "Path 10187",
    d: "M5221.618-7375.927v16.063l12.037-7.44Z",
    transform: "translate(-5221.618 7375.927)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11773",
    "data-name": "Path 11773",
    d: "M937.438,246.062v16.064",
    transform: "translate(-924.479 -246.062)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup19263);
export default __webpack_public_path__ + "static/media/Group 19263.61bce79da17f66dbf24ffafa83788560.svg";
export { ForwardRef as ReactComponent };